
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoParaDialog extends Serenity.EntityDialog<PoParaRow, any> {
        protected getFormKey() { return PoParaForm.formKey; }
        protected getIdProperty() { return PoParaRow.idProperty; }
        protected getLocalTextPrefix() { return PoParaRow.localTextPrefix; }
        protected getNameProperty() { return PoParaRow.nameProperty; }
        protected getService() { return PoParaService.baseUrl; }
        // protected getDeletePermission() { return PoParaRow.deletePermission; }
        // protected getInsertPermission() { return PoParaRow.insertPermission; }
        protected getUpdatePermission() { return PoParaRow.updatePermission; }

        protected form = new PoParaForm(this.idPrefix);

    }
}